export default 'pages-config'
